import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { useSelectedAccount } from '@ibk/shared-auth';
import { Loading } from '@ibk/shared-ui';
import { saveBelvoExternalId } from '../../../../../services/belvoExternalId';
import styles from '../ConsentModal.module.css';
export const WidgetBelvo = ({ belvoToken, handleCloseConsentModal, }) => {
    const { selectedAccount } = useSelectedAccount();
    const [isLoading, setIsLoading] = useState(true);
    const [isLoaded, setIsLoaded] = useState(false);
    const targetId = selectedAccount?.targetId;
    const widgetRef = useRef(null);
    useEffect(() => {
        saveBelvoExternalId(targetId);
    }, [targetId]);
    let belvoUri = `https://widget.belvo.io?access_token=${belvoToken.widgetToken.access}&external_id=${targetId}&mode=webapp`;
    belvoUri += `&${buildPayload(belvoToken.widgetPayload)}`;
    const handleLoad = () => {
        if (!isLoaded) {
            setIsLoaded(true);
            setIsLoading(false);
            return;
        }
        handleCloseConsentModal();
    };
    return (_jsxs(_Fragment, { children: [isLoading && (_jsx("div", { "data-testid": 'containerConsentModalBelvoLoading', className: styles.loading, children: _jsx(Loading, {}) })), _jsx("iframe", { ref: widgetRef, onLoad: () => {
                    handleLoad();
                }, id: 'belvoWidget', "data-testid": 'iframeConsentModalBelvoWidget', title: 'Belvo', width: '100%', height: '550', style: { border: 'none' }, src: belvoUri, sandbox: 'allow-scripts allow-top-navigation allow-same-origin allow-forms allow-modals allow-popups allow-popups-to-escape-sandbox' })] }));
};
export const buildPayload = (rawPayload) => !!rawPayload &&
    Object.keys(rawPayload)
        .map(key => `${key}=${rawPayload[key]}`)
        .join('&');
